export default function Footer() {
  return (
    <footer
      className="border-t mt-8"
      style={{ background: '#fffbf2', borderColor: '#e8d9b0' }}
    >
      <div className="max-w-6xl mx-auto px-6 py-10">
        {/* Main footer grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="text-2xl">🥭</span>
              <span className="font-bold text-lg" style={{ color: '#7c2d12' }}>Mango Calculator Hub</span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: '#78716c' }}>
              Professional-grade mango cultivation tools for farmers, agronomists, food processors, and home gardeners worldwide.
            </p>
          </div>

          {/* SEO Keyword Targets */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#a16207' }}>
              Calculator Tools
            </h3>
            <ul className="space-y-2">
              {[
                'Mango Orchard Spacing Calculator',
                'Mango Fertilizer Calculator',
                'Mango Tree Yield Calculator',
                'Mango Brix Calculator',
                'Mango Maturity Index',
                'Ultra High Density Mango Plantation',
              ].map((kw) => (
                <li key={kw}>
                  <span
                    className="text-sm hover:underline cursor-pointer transition-colors"
                    style={{ color: '#92400e' }}
                  >
                    {kw}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Standards */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#a16207' }}>
              Methodology & Standards
            </h3>
            <p className="text-sm leading-relaxed" style={{ color: '#78716c' }}>
              All calculation methodologies are compiled based on <strong className="font-semibold" style={{ color: '#7c2d12' }}>international horticultural standards</strong>, including FAO guidelines, ICAR mango production protocols, and internationally peer-reviewed agronomy research for tropical fruit cultivation.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t pt-6" style={{ borderColor: '#e8d9b0' }}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-center" style={{ color: '#a8a29e' }}>
              © {new Date().getFullYear()} Mango Calculator Hub — www.mangocalculator.com. For educational and planning purposes only. Always consult a licensed agronomist for specific farm management decisions.
            </p>
            <div
              className="flex items-center gap-2 px-4 py-2 rounded-full border text-xs font-semibold"
              style={{ background: '#fef9c3', borderColor: '#fde68a', color: '#78350f' }}
            >
              🌱 Built for Mango Growers Worldwide
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
